const financialAccounts = {
  list: {
    title: 'Cuentas Financieras',
    search: {
      placeholder: 'Buscar cuentas...',
      label: 'Buscar cuentas',
    },
    typeFilter: {
      label: 'Filtro por tipo de cuenta',
      placeholder: 'Seleccionar tipo de cuenta',
      options: {
        all: 'Todos los Tipos',
        cash: 'Efectivo',
        checking: 'Cuenta Corriente',
        savings: 'Ahorros',
      },
    },
    buttons: {
      newAccount: 'Nueva Cuenta',
      syncTransactions: 'Sincronizar Transacciones',
      edit: 'Editar',
    },
    status: {
      hiddenForPurchases: 'Oculta para Compras',
      lastUpdate: 'Ultima actualizacion',
    },
    empty: {
      description: 'Aun no se han creado cuentas financieras',
      createPrompt: 'Haz clic en el boton Crear Cuenta para comenzar.',
      button: 'Crear Cuenta',
    },
    viewTransactions: 'Ver Transacciones',
    viewDisable: 'Ver Desactivar',
    reconcile: 'Conciliar',
    tooltips: {
      linked: 'Vinculada a Plaid',
      notLinked: 'No vinculada a Plaid',
      visibleInPayments: 'Visible en pagos',
      hiddenFromPayments: 'Oculta en pagos',
    },
    selection: {
      singular: 'cuenta seleccionada',
      plural: 'cuentas seleccionadas',
    },
  },
  transactions: {
    drawer: {
      title: (accountName: string) => `${accountName} - Transacciones`,
      empty: {
        title: 'No se encontraron pagos',
        description: 'No hay pagos registrados para esta cuenta financiera.',
      },
    },
  },
  errors: {
    loadingAccounts: (message: string) =>
      `Error al cargar cuentas financieras: ${message}`,
  },
  dialog: {
    title: {
      create: 'Nueva Cuenta',
      edit: 'Editar Cuenta',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Cuenta',
      save: 'Guardar Cambios',
    },
  },
  form: {
    fields: {
      accountName: 'Nombre de la Cuenta',
      accountType: 'Tipo de Cuenta',
      accountTypePlaceholder: 'Seleccionar Tipo de Cuenta',
      facility: 'Instalacion',
      initialBalance: 'Saldo Inicial',
      initialBalanceDisabled:
        'El saldo inicial no se puede cambiar despues de la creacion',
      roundingMethod: 'Metodo de Redondeo',
      roundingMethodPlaceholder: 'Seleccionar Metodo de Redondeo',
      roundingPrecision: 'Precision de Redondeo',
      roundingPrecisionPlaceholder: 'Seleccionar Precision de Redondeo',
      visibleInPayments: 'Hacer esta cuenta disponible para pagos',
      nachaConfig: 'Configuracion NACHA',
      nachaCompanyIdentification: 'Identificacion de Empresa',
      nachaCompanyName: 'Nombre de Empresa',
      paymentAllocationMethod: 'Metodo de Asignacion de Pago',
      paymentAllocationMethodPlaceholder:
        'Seleccionar Metodo de Asignacion de Pago',
      nachaDefaultSecCode: 'Codigo SEC Predeterminado',
      nachaDefaultSecCodePlaceholder: 'Seleccionar Codigo SEC',
    },
  },
  plaid: {
    linkButton: 'Vincular Cuentas',
    facilityDialog: {
      title: 'Asignar Instalacion',
      description: 'Selecciona una instalacion para tus cuentas vinculadas',
      facilityLabel: 'Instalacion',
      applyToAll: 'Aplicar la misma instalacion a todas las cuentas',
      accountsToConnect: 'Cuentas a conectar:',
      connect: 'Conectar Cuentas',
      cancel: 'Cancelar',
    },
    messages: {
      syncSuccess: 'Cuentas sincronizadas exitosamente',
      syncError: 'Error al sincronizar cuentas',
      initError: 'Error al inicializar Plaid Link',
      connectSuccess: 'Cuenta bancaria conectada exitosamente',
      connectError: 'Error al conectar cuenta bancaria.',
    },
  },
  reconcile: {
    title: 'Conciliar Caja',
    fields: {
      physicalCount: 'Conteo Fisico',
      notes: 'Notas',
    },
    buttons: {
      cancel: 'Cancelar',
      reconcile: 'Conciliar',
    },
    messages: {
      success: 'Caja conciliada exitosamente',
      error: (message: string) => `Error al conciliar: ${message}`,
    },
  },
  checkTemplate: {
    title: 'Configuracion de Plantilla de Cheque',
    sections: {
      layout: 'Diseno',
      displayOptions: 'Opciones de Visualizacion',
      signatures: 'Configuracion de Firmas',
      font: 'Configuracion de Fuente',
    },
    fields: {
      checkType: 'Tipo de Cheque',
      checkLayout: 'Diseno del Cheque',
      displayPayeeName: 'Nombre del Beneficiario',
      displayPayeeAddress: 'Direccion del Beneficiario',
      displayDate: 'Fecha',
      displayAmount: 'Monto',
      displayAmountWords: 'Monto en Palabras',
      displayMemo: 'Memo',
      displayAccountNumber: 'Numero de Cuenta',
      displayBankInfo: 'Informacion Bancaria',
      displaySignature: 'Firma',
      displaySecondSignature: 'Segunda Firma',
      displayCompanyName: 'Nombre de la Empresa',
      displayCompanyAddress: 'Direccion de la Empresa',
      displayCompanyPhone: 'Telefono de la Empresa',
      displayCheckNumber: 'Numero de Cheque',
      displayMicr: 'Línea MICR',
      minAmountSignature: 'Monto Minimo para Firma',
      maxAmountSecondSignature: 'Monto Maximo para Segunda Firma',
      checkFont: 'Fuente',
      checkFontSize: 'Tamano de Fuente',
    },
    checkTypes: {
      preprintedPaper: 'Papel Preimpreso',
      blankPaper: 'Papel en Blanco',
    },
    checkLayouts: {
      checkAtTop: 'Cheque Arriba',
      checkAtMiddle: 'Cheque en el Medio',
      checkAtBottom: 'Cheque Abajo',
    },
    buttons: {
      cancel: 'Cancelar',
      save: 'Guardar Configuracion',
    },
    messages: {
      success: 'Configuracion de plantilla de cheque guardada',
      error: (message: string) => `Error al guardar configuracion: ${message}`,
    },
  },
  positivePay: {
    title: 'Generar Archivo de Pago Positivo',
    fields: {
      template: 'Plantilla',
      financialAccount: 'Cuenta Financiera',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
    },
    buttons: {
      cancel: 'Cancelar',
      generate: 'Generar Archivo',
    },
    messages: {
      success: 'Archivo de pago positivo generado y descargado',
      error: (message: string) => `Error al generar archivo: ${message}`,
    },
  },
};

const overview = {
  title: 'Resumen Financiero',
  subtitle: 'Resumen de sus operaciones financieras',
  kpi: {
    pendingBills: 'Facturas Pendientes',
    pendingInvoices: 'Cobros Pendientes',
    totalAP: 'Total CP Pendiente',
    totalAR: 'Total CC Pendiente',
    otherCurrencies: (count: number) =>
      count === 1 ? '+1 otra moneda' : `+${count} otras monedas`,
  },
  financialAccounts: {
    title: 'Cuentas Financieras',
    subtitle: 'Saldos de cuentas',
    empty: 'No se encontraron cuentas financieras',
    columns: {
      name: 'Cuenta',
      type: 'Tipo',
      balance: 'Saldo',
    },
  },
  aging: {
    title: 'Antigüedad CC/CP',
    subtitle: 'Desglose de vencimientos',
    empty: 'No hay facturas ni cobros pendientes',
    buckets: {
      current: 'Vigente',
      days1to30: '1-30 días',
      days31to60: '31-60 días',
      days61to90: '61-90 días',
      days90plus: '90+ días',
    },
    series: {
      ap: 'CP (Facturas)',
      ar: 'CC (Cobros)',
    },
  },
  recentBills: {
    title: 'Facturas Recientes',
    subtitle: 'Sus últimas facturas y pagos',
    empty: 'No se encontraron facturas',
  },
  recentInvoices: {
    title: 'Cobros Recientes',
    subtitle: 'Sus últimos cobros y cuentas por cobrar',
    empty: 'No se encontraron cobros',
  },
  columns: {
    documentNumber: 'Doc #',
    account: 'Cuenta',
    dueDate: 'Fecha de Vencimiento',
    amount: 'Monto',
    status: 'Estado',
  },
};

const balances = {
  list: {
    title: 'Saldos',
    search: {
      placeholder: 'Buscar cuentas...',
      label: 'Buscar cuentas',
    },
    buttons: {
      receive: (currency: string) => `Recibir ${currency}`,
      pay: (currency: string) => `Pagar ${currency}`,
      more: '...',
    },
    empty: {
      title: 'No se encontraron saldos',
      description: 'No hay saldos de cuenta que coincidan con tus criterios',
    },
    error: (message: string) => `Error al obtener saldos: ${message}`,
    ariaLabel: 'Lista de Saldos',
    selected: (count: number) =>
      `${count === 1 ? 'cuenta seleccionada' : 'cuentas seleccionadas'}`,
  },
  netPay: {
    title: 'Pago Neto',
    fields: {
      accountName: 'Cuenta',
      paymentMethod: 'Metodo de Pago',
      financialAccount: 'Cuenta Financiera',
      transactionDate: 'Fecha de Transaccion',
      checkNumber: 'Numero de Cheque',
      checkMemo: 'Memo del Cheque',
      checkFacility: 'Instalacion del Cheque',
      achNumber: 'Numero ACH',
      wireNumber: 'Numero de Transferencia',
    },
    buttons: {
      cancel: 'Cancelar',
      submit: 'Crear Pago Neto',
    },
    result: {
      payableTotal: 'Total por Pagar',
      receivableTotal: 'Total por Cobrar',
      netAmount: 'Monto Neto',
    },
    messages: {
      success: 'Pago neto creado exitosamente',
    },
  },
};

const bills = {
  list: {
    title: 'Facturas de Compra',
    search: {
      placeholder: 'Buscar facturas...',
      label: 'Buscar facturas',
      facilityPlaceholder: 'Buscar instalaciones...',
    },
    status: {
      label: 'Estado',
      options: {
        all: 'Todos los Estados',
        pending: 'Pendiente',
        paid: 'Pagada',
        voided: 'Anulada',
      },
      badge: {
        pending: 'Pendiente',
        paid: 'Pagada',
        voided: 'Anulada',
      },
    },
    columns: {
      facility: 'Instalacion',
    },
    toolbar: {
      selected: 'seleccionados',
      pay: (count: number) => `Pagar ${count}`,
      void: (count: number) => `Anular ${count}`,
      voidSuccess: (count: number) =>
        count === 1
          ? 'Se anuló 1 factura exitosamente'
          : `Se anularon ${count} facturas exitosamente`,
      voidPartial: (succeeded: number, total: number) =>
        `${succeeded} de ${total} facturas anuladas. ${total - succeeded} fallaron.`,
      voidFailed: 'Error al anular facturas',
    },
    buttons: {
      pay: 'Pagar',
      void: 'Anular',
      more: '...',
      viewDetails: 'Ver Detalles',
      payMultiple: ({ count, type }: { count: number; type: string }) =>
        `Pagar ${count} ${type}`,
      create: 'Crear Factura',
    },
    tooltips: {
      notAllPending: 'Solo las facturas pendientes pueden ser pagadas',
      cannotVoid: 'Solo las facturas pendientes pueden ser anuladas',
      differentAccounts:
        'Las facturas seleccionadas deben ser de la misma cuenta',
      differentFacilities:
        'Las facturas seleccionadas deben ser de la misma instalacion',
    },
    error: (message: string) => `Error al cargar facturas: ${message}`,
    viewModes: { all: 'Todos', byAccount: 'Por Cuenta' },
    groupHeader: {
      unknownAccount: 'Cuenta Desconocida',
      billCount: (count: number) =>
        count === 1 ? '1 factura' : `${count} facturas`,
      outstanding: (total: string) => `${total} pendiente`,
    },
    documentNumber: (number: number | string) => `BILL-${number}`,
  },
  detail: {
    title: 'Detalles de Factura',
    tabs: {
      info: 'Informacion',
      lineItems: 'Lineas de Detalle',
      payments: 'Pagos',
    },
    fields: {
      type: 'Tipo',
      status: 'Estado',
      facility: 'Instalacion',
      documentNumber: 'Numero de Documento',
      documentDate: 'Fecha del Documento',
      dueDate: 'Fecha de Vencimiento',
      amount: 'Monto',
      openAmount: 'Monto Pendiente',
      currency: 'Moneda',
      paymentTerm: 'Termino de Pago',
      notes: 'Notas',
      eligibleAt: 'Elegible En',
      preferredPaymentMethod: 'Metodo de Pago Preferido',
    },
    sections: {
      basicInfo: 'Informacion Basica',
      payments: 'Pagos',
    },
    actions: {
      void: 'Anular Factura',
      markAsPaid: 'Marcar como Pagada',
    },
    messages: {
      voided: 'La factura ha sido anulada exitosamente',
      voidError: (message: string) => `Error al anular factura: ${message}`,
      paymentRemoved: 'Pago eliminado exitosamente',
      removePaymentError: (message: string) =>
        `Error al eliminar pago: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar factura: ${message}`,
    },
    empty: {
      lineItems: 'No hay lineas de detalle para esta factura',
      noData: 'No hay datos de factura disponibles.',
    },
    payments: {
      empty: 'No hay pagos aplicados a esta factura.',
      applyPayment: 'Aplicar Pago',
      columns: {
        paymentNumber: 'Pago #',
        appliedAmount: 'Aplicado',
        date: 'Fecha',
      },
    },
    unsavedChanges: {
      message: 'Tienes cambios sin guardar',
      discard: 'Descartar',
      save: 'Guardar Cambios',
    },
    footer: {
      totalAmount: 'Monto Total',
      totalPaid: 'Total Pagado',
      numberOfPayments: '# de Pagos',
      openAmount: 'Monto Pendiente',
    },
  },
  wizard: {
    steps: {
      basicInfo: 'Informacion Basica',
      lineItems: 'Lineas de Detalle',
    },
    fields: {
      documentNumber: 'Numero de Documento',
      documentNumberDescription: 'Se genera automaticamente al crear',
      billType: 'Tipo de Factura',
      facility: 'Instalacion',
      account: 'Cuenta',
      documentDate: 'Fecha del Documento',
      eligibleAt: 'Elegible En',
      paymentTerm: 'Termino de Pago',
      paymentMethod: 'Metodo de Pago',
      currency: 'Moneda',
      notes: 'Notas',
    },
    buttons: {
      back: 'Atras',
      cancel: 'Cancelar',
      create: 'Crear Factura',
      next: 'Siguiente',
    },
    validation: {
      billTypeRequired: 'El tipo de factura es obligatorio',
      documentDateRequired: 'La fecha del documento es obligatoria',
      facilityRequired: 'La instalacion es obligatoria',
      paymentTermRequired: 'El termino de pago es obligatorio',
      paymentMethodRequired: 'El metodo de pago es obligatorio',
    },
    messages: {
      createSuccess: 'Factura creada exitosamente',
      createError: (message: string) => `Error al crear factura: ${message}`,
    },
  },
  lineItems: {
    title: 'Lineas de Detalle',
    addButton: 'Agregar Linea de Detalle',
    ariaLabel: 'Lineas de detalle de la factura',
    empty: 'No hay lineas de detalle para esta factura.',
    fields: {
      description: 'Descripcion',
      descriptionPlaceholder: 'Descripcion',
      quantity: 'Cantidad',
      unit: 'Unidad',
      unitPlaceholder: 'Unidad',
      unitPrice: 'Precio Unitario',
      total: 'Total',
      groupName: 'Grupo',
      groupNamePlaceholder: 'Seleccionar o crear grupo...',
    },
  },
  paymentDrawer: {
    cannotProcess: {
      title: 'No se Puede Procesar el Pago',
      message:
        'No se pueden pagar multiples facturas de diferentes cuentas simultaneamente. Por favor selecciona facturas de la misma cuenta.',
      differentFacilities:
        'No se pueden pagar multiples facturas de diferentes instalaciones simultaneamente. Por favor selecciona facturas de la misma instalacion.',
      close: 'Cerrar',
    },
    title: {
      single: 'Pagar Factura',
      multiple: 'Pagar Multiples Facturas',
    },
    fields: {
      payee: 'Beneficiario',
      billNumber: 'Numero de Factura',
      bills: 'Facturas',
      billsSelected: (count: number) => `${count} facturas seleccionadas`,
      totalAmount: 'Monto Total',
      paymentAmount: 'Monto del Pago',
      originalTotal: (amount: string) => `Total adeudado: ${amount}`,
      paymentMethod: 'Metodo de Pago',
      transactionDate: 'Fecha de Transaccion',
      financialAccount: 'Cuenta Financiera',
      checkFacility: 'Instalacion del Cheque',
      checkNumber: 'Numero de Cheque',
      startingCheckNumber: 'Numero de Cheque Inicial',
      checkMemo: 'Memo del Cheque',
      achNumber: 'Numero ACH',
      wireNumber: 'Numero de Transferencia',
      due: 'adeudado',
      duePrefix: 'Vence',
      noDueDate: 'Sin fecha de vencimiento',
    },
    buttons: {
      cancel: 'Cancelar',
      pay: 'Pagar Ahora',
    },
    allocationBanner: {
      message: (method: string) => {
        const names: Record<string, string> = {
          FIFO: 'FIFO',
          LIFO: 'LIFO',
          WeightedDistribution: 'Distribución Ponderada',
        };
        return `Esta cuenta usa ${names[method] ?? method} distribución.`;
      },
      apply: 'Aplicar',
      keepCurrent: 'Mantener Actual',
    },
    messages: {
      success: 'Pago creado y aplicado exitosamente',
      error: (message: string) => `Error al procesar el pago: ${message}`,
      partialSuccess: (succeeded: number, total: number) =>
        `${succeeded} de ${total} pagos exitosos. ${total - succeeded} fallaron.`,
      mixedCurrency:
        'Los pagos en lote con diferentes monedas no son compatibles. Pague cada grupo de moneda por separado.',
      checkAutoIncrement: (start: string, end: string) =>
        `Los numeros de cheque seran asignados del ${start} al ${end}.`,
    },
  },
  applyPaymentDialog: {
    fields: {
      selectPayment: 'Pago',
      selectPaymentPlaceholder: 'Seleccionar un pago...',
    },
    loading: 'Cargando pagos...',
    noPaymentsAvailable: 'No hay pagos disponibles',
    createNewPayment: 'Crear Nuevo Pago',
    unknownAccount: 'Cuenta Desconocida',
    availableSuffix: 'disponible',
    paymentAvailable: 'Pago disponible',
    billOpen: 'Monto pendiente de la factura',
  },
};

const invoices = {
  list: {
    title: 'Facturas de Venta',
    search: {
      placeholder: 'Buscar facturas...',
      label: 'Buscar facturas',
    },
    status: {
      label: 'Estado',
      options: {
        all: 'Todos los Estados',
        proForma: 'Pro Forma',
        pending: 'Pendiente',
        paid: 'Pagada',
        voided: 'Anulada',
      },
      badge: {
        proForma: 'Pro Forma',
        pending: 'Pendiente',
        paid: 'Pagada',
        voided: 'Anulada',
      },
    },
    columns: {
      facility: 'Instalacion',
    },
    toolbar: {
      selected: 'seleccionados',
      receive: (count: number) => `Recibir ${count}`,
      void: (count: number) => `Anular ${count}`,
      voidSuccess: (count: number) =>
        count === 1
          ? 'Se anuló 1 factura exitosamente'
          : `Se anularon ${count} facturas exitosamente`,
      voidPartial: (succeeded: number, total: number) =>
        `${succeeded} de ${total} facturas anuladas. ${total - succeeded} fallaron.`,
      voidFailed: 'Error al anular facturas',
    },
    buttons: {
      receive: 'Recibir',
      void: 'Anular',
      more: '...',
      viewDetails: 'Ver Detalles',
      receiveMultiple: (count: number) =>
        count === 0
          ? 'Recibir'
          : count === 1
            ? `Recibir ${count} Factura`
            : `Recibir ${count} Facturas`,
      create: 'Crear Factura',
    },
    tooltips: {
      notAllPending: 'Solo las facturas pendientes pueden recibir pagos',
      cannotVoid:
        'Solo las facturas pendientes o pro forma pueden ser anuladas',
      differentAccounts:
        'Las facturas seleccionadas deben ser de la misma cuenta',
      differentFacilities:
        'Las facturas seleccionadas deben ser de la misma instalacion',
    },
    error: (message: string) => `Error al cargar facturas: ${message}`,
    viewModes: { all: 'Todos', byAccount: 'Por Cuenta' },
    groupHeader: {
      unknownAccount: 'Cuenta Desconocida',
      invoiceCount: (count: number) =>
        count === 1 ? '1 factura' : `${count} facturas`,
      outstanding: (total: string) => `${total} pendiente`,
    },
    documentNumber: (number: number | string) => `INV-${number}`,
  },
  detail: {
    title: 'Detalles de Factura',
    tabs: {
      info: 'Informacion',
      lineItems: 'Lineas de Detalle',
      payments: 'Pagos',
    },
    fields: {
      type: 'Tipo',
      status: 'Estado',
      facility: 'Instalacion',
      documentNumber: 'Numero de Documento',
      documentDate: 'Fecha del Documento',
      dueDate: 'Fecha de Vencimiento',
      amount: 'Monto',
      openAmount: 'Monto Pendiente',
      currency: 'Moneda',
      paymentTerm: 'Termino de Pago',
      notes: 'Notas',
    },
    actions: {
      void: 'Anular Factura',
      markAsPaid: 'Marcar como Pagada',
    },
    messages: {
      voided: 'La factura ha sido anulada exitosamente',
      voidError: (message: string) => `Error al anular factura: ${message}`,
      paymentRemoved: 'Pago eliminado exitosamente',
      removePaymentError: (message: string) =>
        `Error al eliminar pago: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar factura: ${message}`,
    },
    empty: {
      lineItems: 'No hay lineas de detalle para esta factura',
      noData: 'No hay datos de factura disponibles.',
    },
    payments: {
      empty: 'No hay pagos aplicados a esta factura.',
      applyPayment: 'Aplicar Pago',
      columns: {
        paymentNumber: 'Pago #',
        appliedAmount: 'Aplicado',
        date: 'Fecha',
      },
    },
    sections: {
      basicInfo: 'Informacion Basica',
    },
    unsavedChanges: {
      message: 'Tienes cambios sin guardar',
      discard: 'Descartar',
      save: 'Guardar Cambios',
    },
    footer: {
      totalAmount: 'Monto Total',
      totalPaid: 'Total Pagado',
      numberOfPayments: '# de Pagos',
      openAmount: 'Monto Pendiente',
    },
  },
  wizard: {
    steps: {
      basicInfo: 'Informacion Basica',
      lineItems: 'Lineas de Detalle',
    },
    fields: {
      documentNumber: 'Numero de Documento',
      documentNumberDescription: 'Se genera automaticamente al crear',
      invoiceType: 'Tipo de Factura',
      facility: 'Instalacion',
      account: 'Cuenta',
      documentDate: 'Fecha del Documento',
      dueDate: 'Fecha de Vencimiento',
      paymentTerm: 'Termino de Pago',
      currency: 'Moneda',
      notes: 'Notas',
    },
    buttons: {
      back: 'Atras',
      cancel: 'Cancelar',
      create: 'Crear Factura',
      next: 'Siguiente',
    },
    validation: {
      invoiceTypeRequired: 'El tipo de factura es obligatorio',
      documentDateRequired: 'La fecha del documento es obligatoria',
      facilityRequired: 'La instalacion es obligatoria',
      accountRequired: 'La cuenta es obligatoria',
      paymentTermRequired: 'El termino de pago es obligatorio',
    },
    messages: {
      createSuccess: 'Factura creada exitosamente',
      createError: (message: string) => `Error al crear factura: ${message}`,
    },
  },
  lineItems: {
    title: 'Lineas de Detalle',
    addButton: 'Agregar Linea de Detalle',
    ariaLabel: 'Lineas de detalle de la factura',
    empty: 'No hay lineas de detalle para esta factura.',
    fields: {
      description: 'Descripcion',
      descriptionPlaceholder: 'Descripcion',
      quantity: 'Cantidad',
      unit: 'Unidad',
      unitPlaceholder: 'Unidad',
      unitPrice: 'Precio Unitario',
      total: 'Total',
      groupName: 'Grupo',
      groupNamePlaceholder: 'Seleccionar o crear grupo...',
    },
  },
  paymentDrawer: {
    cannotProcess: {
      title: 'No se Puede Procesar el Pago',
      message:
        'No se pueden cobrar multiples facturas de diferentes cuentas simultaneamente. Por favor selecciona facturas de la misma cuenta.',
      differentFacilities:
        'No se pueden cobrar multiples facturas de diferentes instalaciones simultaneamente. Por favor selecciona facturas de la misma instalacion.',
      close: 'Cerrar',
    },
    title: {
      single: 'Recibir Pago',
      multiple: 'Recibir Multiples Pagos',
    },
    fields: {
      customer: 'Cliente',
      invoiceNumber: 'Numero de Factura',
      invoices: 'Facturas',
      invoicesSelected: (count: number) => `${count} facturas seleccionadas`,
      totalAmount: 'Monto Total',
      paymentAmount: 'Monto del Pago',
      originalTotal: (amount: string) => `Total adeudado: ${amount}`,
      paymentMethod: 'Metodo de Pago',
      transactionDate: 'Fecha de Transaccion',
      financialAccount: 'Cuenta Financiera',
      checkFacility: 'Instalacion del Cheque',
      checkNumber: 'Numero de Cheque',
      startingCheckNumber: 'Numero de Cheque Inicial',
      checkMemo: 'Memo del Cheque',
      achNumber: 'Numero ACH',
      wireNumber: 'Numero de Transferencia',
      due: 'adeudado',
      duePrefix: 'Vence',
      noDueDate: 'Sin fecha de vencimiento',
    },
    buttons: {
      cancel: 'Cancelar',
      receive: 'Recibir Ahora',
    },
    allocationBanner: {
      message: (method: string) => {
        const names: Record<string, string> = {
          FIFO: 'FIFO',
          LIFO: 'LIFO',
          WeightedDistribution: 'Distribución Ponderada',
        };
        return `Esta cuenta usa ${names[method] ?? method} distribución.`;
      },
      apply: 'Aplicar',
      keepCurrent: 'Mantener Actual',
    },
    messages: {
      success: 'Pago recibido y aplicado exitosamente',
      error: (message: string) => `Error al procesar el pago: ${message}`,
      partialSuccess: (succeeded: number, total: number) =>
        `${succeeded} de ${total} pagos exitosos. ${total - succeeded} fallaron.`,
      mixedCurrency:
        'Los pagos en lote con diferentes monedas no son compatibles. Pague cada grupo de moneda por separado.',
      checkAutoIncrement: (start: string, end: string) =>
        `Los numeros de cheque seran asignados del ${start} al ${end}.`,
    },
  },
  applyPaymentDialog: {
    fields: {
      selectPayment: 'Pago',
      selectPaymentPlaceholder: 'Seleccionar un pago...',
    },
    loading: 'Cargando pagos...',
    noPaymentsAvailable: 'No hay pagos disponibles',
    createNewPayment: 'Crear Nuevo Pago',
    unknownAccount: 'Cuenta Desconocida',
    availableSuffix: 'disponible',
    paymentAvailable: 'Pago disponible',
    invoiceOpen: 'Monto pendiente de la factura',
  },
};

const lineItems = {
  columns: {
    description: 'Descripcion',
    quantity: 'Cantidad',
    unit: 'Unidad',
    unitPrice: 'Precio Unitario',
    totalPrice: 'Precio Total',
  },
  placeholders: {
    selectItem: 'Seleccionar articulo...',
    enterDescription: 'Ingresar descripcion...',
  },
  addButton: 'Agregar Partida',
  footer: {
    items: (count: number) => (count === 1 ? '1 partida' : `${count} partidas`),
  },
};

const payments = {
  list: {
    title: 'Pagos',
    search: {
      placeholder: 'Buscar pagos...',
      label: 'Buscar pagos',
    },
    status: {
      options: {
        issued: 'Emitido',
        posted: 'Registrado',
        voided: 'Anulado',
      },
    },
    methodFilter: {
      label: 'Método',
      options: {
        Check: 'Cheque',
        ACH: 'ACH',
        Wire: 'Transferencia',
        Cash: 'Efectivo',
        ATM: 'ATM',
      } as Record<string, string>,
    },
    dateFilter: {
      label: 'Rango de Fechas',
      clear: 'Limpiar',
      done: 'Listo',
    },
    columns: {
      financialAccount: 'Cuenta Financiera',
      linkedDocuments: 'Documentos Vinculados',
      linkedDocumentsMore: ({ count }: { count: number }) => `+${count} más`,
    },
    toolbar: {
      selected: 'seleccionados',
      generateAchFile: 'Generar Archivo ACH',
      printChecks: 'Imprimir Cheques',
    },
    bulkActions: {
      confirm: 'Confirmar',
      unconfirm: 'Desconfirmar',
      confirmSuccess: ({ count }: { count: number }) =>
        `${count} pagos confirmados exitosamente`,
      unconfirmSuccess: ({ count }: { count: number }) =>
        `${count} pagos desconfirmados exitosamente`,
      partialFailure: ({
        failedCount,
        totalCount,
      }: {
        failedCount: number;
        totalCount: number;
      }) => `${failedCount} de ${totalCount} pagos fallaron`,
    },
    buttons: {
      applyAdvance: 'Aplicar Anticipo',
      viewDetails: 'Ver Detalles',
      create: 'Crear Pago',
    },
    error: (message: string) => `Error al cargar pagos: ${message}`,
  },
  detail: {
    title: 'Detalles del Pago',
    createdOn: 'Creado el',
    updatedOn: 'Actualizado el',
    tabs: {
      info: 'Informacion',
      linkedDocuments: 'Documentos Vinculados',
    },
    fields: {
      documentNumber: 'Numero de Documento',
      status: 'Estado',
      paymentType: 'Tipo de Pago',
      transactionDate: 'Fecha de Transaccion',
      amount: 'Monto',
      unappliedAmount: 'Monto sin Aplicar',
      paymentMethod: 'Metodo de Pago',
      account: 'Cuenta',
      financialAccount: 'Cuenta Financiera',
      checkNumber: 'Numero de Cheque',
      checkMemo: 'Memo del Cheque',
      achNumber: 'Numero ACH',
      wireNumber: 'Numero de Transferencia',
    },
    actions: {
      void: 'Anular',
      applyToBill: 'Aplicar a Factura de Compra',
      applyToInvoice: 'Aplicar a Factura de Venta',
    },
    messages: {
      updateSuccess: 'Pago actualizado exitosamente',
      updateError: (message: string) => `Error al actualizar pago: ${message}`,
      loadError: (message: string) => `Error al cargar pago: ${message}`,
      voidSuccess: 'El pago ha sido anulado exitosamente',
      voidError: (message: string) => `Error al anular pago: ${message}`,
      paymentApplied: 'Pago aplicado exitosamente',
      paymentRemoved: 'Vinculo de pago eliminado exitosamente',
      applyError: (message: string) => `Error al aplicar pago: ${message}`,
      removeError: (message: string) =>
        `Error al eliminar vinculo de pago: ${message}`,
    },
    linkedDocuments: {
      billNumber: 'Numero de Factura de Compra',
      invoiceNumber: 'Numero de Factura de Venta',
      appliedAmount: 'Monto Aplicado',
      appliedAt: 'Aplicado En',
      linkedBills: 'Facturas de Compra Vinculadas',
      linkedInvoices: 'Facturas de Venta Vinculadas',
      emptyState: 'No hay facturas vinculadas a este pago.',
      removeBill: 'Quitar factura de compra',
      removeInvoice: 'Quitar factura de venta',
    },
    voidDialog: {
      title: 'Anular Pago',
      message:
        'Esta seguro de que desea anular este pago? Esta accion no se puede deshacer.',
      cascadeEffects: {
        unlinkBills: (count: number) =>
          `${count} factura(s) de compra seran desvinculadas de este pago`,
        unlinkInvoices: (count: number) =>
          `${count} factura(s) de venta seran desvinculadas de este pago`,
        restoreBalance: 'El saldo de la cuenta financiera sera restaurado',
      },
      buttons: {
        cancel: 'Cancelar',
        void: 'Anular Pago',
      },
    },
    unsavedChanges: {
      message: 'Tienes cambios sin guardar',
      discard: 'Descartar',
      save: 'Guardar Cambios',
    },
    sections: {
      basicInfo: 'Información Básica',
      checkDetails: 'Detalles del Cheque',
      achDetails: 'Detalles ACH',
      wireDetails: 'Detalles de Transferencia',
    },
    footer: {
      totalAmount: 'Monto Total',
      totalApplied: 'Total Aplicado',
      linkedDocuments: 'Documentos Vinculados',
      unappliedAmount: 'Monto No Aplicado',
    },
    empty: {
      noData: 'No hay datos de pago disponibles.',
    },
    dialogs: {
      applyToBill: {
        title: 'Aplicar Pago a Factura de Compra',
        billLabel: 'Seleccionar Factura',
        selectBill: 'Elegir una factura...',
        amountLabel: 'Monto a Aplicar',
        unappliedBalance: 'Saldo sin aplicar',
        billAmount: 'Monto de factura',
        openBalance: 'Saldo pendiente',
        noBillsAvailable:
          'No hay facturas abiertas disponibles para esta cuenta',
        unknownAccount: 'Desconocida',
        openSuffix: 'pendiente',
        loading: 'Cargando...',
      },
      applyToInvoice: {
        title: 'Aplicar Pago a Factura de Venta',
        invoiceLabel: 'Seleccionar Factura',
        selectInvoice: 'Elegir una factura...',
        amountLabel: 'Monto a Aplicar',
        unappliedBalance: 'Saldo sin aplicar',
        invoiceAmount: 'Monto de factura',
        openBalance: 'Saldo pendiente',
        noInvoicesAvailable:
          'No hay facturas abiertas disponibles para esta cuenta',
        unknownAccount: 'Desconocida',
        openSuffix: 'pendiente',
        loading: 'Cargando...',
      },
    },
  },
  wizard: {
    fields: {
      documentNumber: 'Numero de Documento',
      documentNumberDescription: 'Se genera automaticamente al crear',
      paymentType: 'Tipo de Pago',
      paymentMethod: 'Metodo de Pago',
      amount: 'Monto',
      currency: 'Moneda',
      transactionDate: 'Fecha de Transaccion',
      account: 'Cuenta',
      financialAccount: 'Cuenta Financiera',
      checkFacility: 'Instalacion del Cheque',
      checkNumber: 'Numero de Cheque',
      checkMemo: 'Memo del Cheque',
      achNumber: 'Numero ACH',
      wireNumber: 'Numero de Transferencia',
    },
    buttons: {
      cancel: 'Cancelar',
      create: 'Crear Pago',
    },
    messages: {
      createSuccess: 'Pago creado exitosamente',
      createError: (message: string) => `Error al crear pago: ${message}`,
    },
    validation: {
      paymentTypeRequired: 'El tipo de pago es obligatorio',
      paymentMethodRequired: 'El metodo de pago es obligatorio',
      amountRequired: 'El monto es obligatorio y debe ser mayor a 0',
      transactionDateRequired: 'La fecha de transaccion es obligatoria',
    },
  },
  advances: {
    apply: {
      title: 'Aplicar Anticipo',
      description:
        'Aplicar este pago anticipado a una factura de compra o venta',
      fields: {
        amount: 'Monto a Aplicar',
        document: 'Aplicar A',
      },
      buttons: {
        apply: 'Aplicar Anticipo',
        cancel: 'Cancelar',
      },
      messages: {
        success: 'Anticipo aplicado exitosamente',
        error: (message: string) => `Error al aplicar anticipo: ${message}`,
      },
    },
  },
  achFile: {
    title: 'Generar Archivo ACH',
    description: ({ count }: { count: number }) =>
      `Generar un archivo NACHA/ACH para ${count} pago(s) seleccionado(s).`,
    fields: {
      financialAccount: 'Cuenta Financiera',
      effectiveEntryDate: 'Fecha Efectiva de Entrada',
    },
    buttons: {
      cancel: 'Cancelar',
      generate: 'Generar Archivo ACH',
    },
    messages: {
      success: 'Archivo ACH generado y descargado',
      error: (message: string) => `Error al generar archivo ACH: ${message}`,
    },
  },
  printChecks: {
    title: 'Imprimir Cheques',
    description: ({ count }: { count: number }) =>
      `Generar un PDF imprimible para ${count} pago(s) de cheque seleccionado(s).`,
    buttons: {
      cancel: 'Cancelar',
      print: 'Imprimir Cheques',
    },
    messages: {
      success: 'PDF de cheques generado exitosamente',
      error: (message: string) => `Error al generar PDF de cheques: ${message}`,
    },
  },
};

const columns = {
  billNumber: 'Factura #',
  supplier: 'Proveedor',
  transactionDate: 'Fecha de Transacción',
  dueDate: 'Fecha de Vencimiento',
  payee: 'Beneficiario',
  payeeType: 'Tipo de Beneficiario',
  balance: 'Saldo',
  balanceOwed: 'Saldo Pendiente',
  currency: 'Moneda',

  invoiceNumber: 'Factura #',
  documentDate: 'Fecha del Documento',
  account: 'Cuenta',
  accountType: 'Tipo de Cuenta',

  status: 'Estado',
  amount: 'Monto',

  date: 'Fecha',
  type: 'Tipo',
  method: 'Metodo',
  unapplied: 'Sin Aplicar',
  documentNumber: 'Doc #',

  accountName: 'Nombre de la Cuenta',
  pendingTransactions: '# de Transacciones',
  balancesColumn: 'Saldos',
};

const messages = {
  common: {
    loading: 'Cargando...',
    unknownError: 'Error desconocido',
  },
  bills: {
    voidSuccess: 'La factura ha sido anulada exitosamente',
    voidError: (message: string) => `Error al anular factura: ${message}`,
    markAsPaidSuccess: 'La factura ha sido marcada como pagada exitosamente',
    markAsPaidError: (message: string) =>
      `Error al marcar factura como pagada: ${message}`,
    createSuccess: 'Factura creada exitosamente',
    updateSuccess: 'Factura actualizada exitosamente',
    loadError: (message: string) => `Error al cargar factura: ${message}`,
  },
  invoices: {
    voidSuccess: 'La factura ha sido anulada exitosamente',
    voidError: (message: string) => `Error al anular factura: ${message}`,
    markAsPaidSuccess: 'La factura ha sido marcada como pagada exitosamente',
    markAsPaidError: (message: string) =>
      `Error al marcar factura como pagada: ${message}`,
    createSuccess: 'Factura creada exitosamente',
    updateSuccess: 'Factura actualizada exitosamente',
    loadError: (message: string) => `Error al cargar factura: ${message}`,
  },
  accounts: {
    createSuccess: 'Cuenta creada exitosamente',
    updateSuccess: 'Cuenta actualizada exitosamente',
    saveError: 'Error al guardar cuenta',
    facilityRequired: 'La instalacion es obligatoria',
  },
};

const common = {
  buttons: {
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear',
    back: 'Atras',
    next: 'Siguiente',
    discard: 'Descartar',
    saveChanges: 'Guardar Cambios',
  },
  placeholders: {
    generateNumber: 'Generar número',
  },
};

const enums = {
  billType: {
    Accrual: 'Devengo',
    FreightBill: 'Factura de Flete',
    InboundBill: 'Factura de Entrada',
    OutboundBill: 'Factura de Salida',
  } as Record<string, string>,
  invoiceType: {
    Accrual: 'Devengo',
    FreightInvoice: 'Factura de Flete',
    InboundInvoice: 'Factura de Entrada',
    OutboundInvoice: 'Factura de Salida',
  } as Record<string, string>,
  paymentType: {
    Adjustment: 'Ajuste',
    AdvanceIn: 'Anticipo Recibido',
    AdvanceOut: 'Anticipo Enviado',
    Bill: 'Pago de Factura',
    Invoice: 'Cobro de Factura',
    Netting: 'Compensacion',
  } as Record<string, string>,
};

const bankDetails = {
  title: 'Datos Bancarios',
  add: 'Agregar Dato Bancario',
  empty: 'No se encontraron datos bancarios',
  fields: {
    bankName: 'Nombre del Banco',
    routingNumber: 'Numero de Ruta',
    accountNumber: 'Numero de Cuenta',
    accountType: 'Tipo de Cuenta',
    isPrimary: 'Cuenta Principal',
    nickname: 'Alias',
  },
  accountTypes: {
    checking: 'Cuenta Corriente',
    savings: 'Ahorros',
  },
  actions: {
    edit: 'Editar',
    delete: 'Eliminar',
    setAsPrimary: 'Establecer como Principal',
  },
  dialog: {
    createTitle: 'Agregar Dato Bancario',
    editTitle: 'Editar Dato Bancario',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  messages: {
    created: 'Dato bancario agregado',
    updated: 'Dato bancario actualizado',
    deleted: 'Dato bancario eliminado',
    error: (message: string) => `Error: ${message}`,
  },
};

const logs = {
  rawPayloadParseError: 'Carga útil sin procesar (Error de análisis)',
  unknownEventType: 'Tipo de evento desconocido',
  unknownEvent: 'Evento desconocido',
  noDataAvailable: 'No hay datos disponibles',
  billDetails: 'Detalles de Factura de Compra',
  invoiceDetails: 'Detalles de Factura de Venta',
  bill: 'Factura de Compra',
  invoice: 'Factura de Venta',
  deletedBill: 'Factura de Compra Eliminada',
  deletedInvoice: 'Factura de Venta Eliminada',
  statusChange: 'Cambio de Estado',
  changes: 'Cambios',
  before: 'Antes',
  after: 'Después',
  events: {
    billCreated: 'Factura de Compra Creada',
    billUpdated: 'Factura de Compra Actualizada',
    billDeleted: 'Factura de Compra Eliminada',
    billVoided: 'Factura de Compra Anulada',
    billPaid: 'Factura de Compra Pagada',
    invoiceCreated: 'Factura de Venta Creada',
    invoiceUpdated: 'Factura de Venta Actualizada',
    invoiceDeleted: 'Factura de Venta Eliminada',
    invoiceVoided: 'Factura de Venta Anulada',
    invoicePaid: 'Factura de Venta Pagada',
  },
};

export const es = {
  financialAccounts,
  overview,
  balances,
  bills,
  invoices,
  lineItems,
  payments,
  columns,
  messages,
  common,
  enums,
  bankDetails,
  logs,
};
